import React, { useState } from 'react';
import { inflatables } from '../utils/mock';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check } from 'lucide-react';

const Catalog = () => {
  const [filter, setFilter] = useState('Todos');
  const categories = ['Todos', 'Castillos Inflables', 'Toboganes Gigantes', 'Pistas de Obstáculos', 'Juegos Interactivos'];

  const filteredInflatables = filter === 'Todos' 
    ? inflatables 
    : inflatables.filter(item => item.category === filter);

  const handleWhatsAppQuote = (inflatable) => {
    const message = `Hola, me interesa el ${inflatable.name} - ${inflatable.category}. ¿Podrían darme más información?`;
    window.open(`https://wa.me/529984830209?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="catalogo" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Catálogo de Inflables
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre nuestra selección premium de inflables para eventos grandes
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                filter === category
                  ? 'bg-gray-900 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredInflatables.map((inflatable) => (
            <div 
              key={inflatable.id}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden bg-gray-100">
                <img 
                  src={inflatable.image} 
                  alt={inflatable.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">
                  <Badge className="bg-white/95 text-gray-900 px-3 py-1 text-sm font-semibold">
                    {inflatable.category}
                  </Badge>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {inflatable.name}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {inflatable.description}
                </p>

                {/* Features */}
                <div className="space-y-2 mb-6">
                  {inflatable.features.slice(0, 3).map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-700">
                      <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                {/* Price and CTA */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div>
                    <p className="text-sm text-gray-500">Desde</p>
                    <p className="text-3xl font-bold text-gray-900">
                      ${inflatable.price.toLocaleString()}
                      <span className="text-lg text-gray-500"> USD</span>
                    </p>
                  </div>
                  <Button
                    onClick={() => handleWhatsAppQuote(inflatable)}
                    className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Cotizar
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center bg-white rounded-2xl p-8 shadow-lg">
          <p className="text-lg text-gray-700 mb-4">
            <span className="font-bold">Todos los precios incluyen:</span> Entrega, instalación profesional, supervisión opcional y retiro
          </p>
          <p className="text-gray-600">
            Los precios pueden variar según la ubicación y duración del evento. Contáctanos para una cotización exacta.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Catalog;
